export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/supplier/dashboard'),
    meta: {
      layoutOptions: {
        containerClass: 'dashboard-home',
        contentClass: 'content-2',
      },
      menuOptions: {
        title: 'Dashboard',
        description: 'En esta sección podrá encontrar información sobre su catálogo y actividad',
      },
    },
  },
  {
    path: '/catalog',
    name: 'catalog',
    redirect: {
      name: 'catalog.search',
    },
    component: {
      render(c) {
        return c('router-view');
      },
    },
    meta: {
      breadcrumb: 'Catálogo',
      menuOptions: {
        title: 'Catálogo',
        description: 'En esta sección podrá realizar búsquedas específicas sobre su catálogo de productos',
      },
    },
    children: [
      {
        path: 'search',
        name: 'catalog.search',
        component: () => import('@/pages/supplier/catalog/search'),
        meta: {
          breadcrumb: 'Búsqueda',
        },
      },
      {
        path: ':item',
        name: 'catalog.products.item',
        component: () => import('@/pages/supplier/catalog/product'),
        meta: {
          breadcrumb() {
            const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
            if (!storeInfo) {
              return 'Producto';
            }

            return `Producto - ${storeInfo.name}`;
          },
        },
      },
    ],
  },
  {
    path: '/request-information',
    name: 'request-information',
    redirect: { name: 'request-information.search' },
    component: {
      render(c) { return c('router-view'); },
    },
    meta: {
      breadcrumb: 'Solicitudes de Información',
      menuOptions: {
        title: 'Solicitudes de Información',
      },
    },
    children: [
      {
        path: 'search',
        name: 'request-information.search',
        component: () => import('@/pages/supplier/request_information/search'),
        meta: {
          breadcrumb: 'Búsqueda',
        },
      },
      {
        path: ':request/request',
        name: 'request-information.request',
        props: route => ({
          requestId: route.params.request,
        }),
        component: () => import('@/pages/supplier/request_information/request'),
        meta: {
          breadcrumb: 'Solicitud de Información',
        },
      },
    ],
  },
  {
    path: '/organization/:slug/profile',
    name: 'organization',
    component: () => import('@/pages/supplier/organization/public-profile'),
    meta: {
      breadcrumb: 'Perfil Proveedor',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/supplier.js